/**
 * Constantes de tiempo compartidas de `apps/web`.
 *
 * PATRÓN A SEGUIR: cualquier duración de caché, debounce o timeout que se use
 * en más de un sitio (o que represente una decisión de producto, no un detalle
 * local) vive aquí, no como `const` suelta dentro de un componente.
 *
 * Motivo: estos valores estaban redeclarados en ~12 archivos con dos grafías
 * distintas del mismo número (`5 * 60 * 1000` y `300_000`), de forma que
 * cambiar la política de caché obligaba a tocar todos esos sitios y arriesgaba
 * dejar valores divergentes. Importa desde aquí en lugar de redefinir.
 */

const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;

/** Milisegundos en un minuto. Base para derivar el resto de duraciones. */
const MINUTE_MS = MS_PER_SECOND * SECONDS_PER_MINUTE;

/** Minutos que un dato cacheado se considera fresco (caché offline y sesión). */
const STALE_MINUTES = 5;

/**
 * `staleTime` por defecto de las queries offline-first (PowerSync + TanStack).
 *
 * Los datos se sincronizan localmente vía PowerSync, así que un `staleTime`
 * generoso (5 min) evita refetches/re-renders redundantes sin riesgo real de
 * mostrar datos obsoletos. Es también el default global del `queryClient`.
 */
export const OFFLINE_CACHE_STALE_TIME_MS = STALE_MINUTES * MINUTE_MS;

/**
 * `staleTime` de las queries de sesión/autenticación.
 *
 * Se mantiene como constante propia (aunque hoy coincida con el valor de
 * caché offline) porque es una decisión independiente: debe estar alineada
 * entre `useSession`, el guard de ruta `_app` y el `session-bridge`.
 */
export const SESSION_STALE_TIME_MS = STALE_MINUTES * MINUTE_MS;

/**
 * Margen tras un error de login social antes de redirigir a `/login`, para que
 * el usuario alcance a leer el toast con el motivo en `/auth/social/callback`.
 */
export const SOCIAL_ERROR_REDIRECT_DELAY_MS = 2500;
